// initial state
const state = {
    logging: []
};

// getters
const getters = {

};

// actions
const actions = {

}

// mutations
const mutations = {

  

    set_tag (state, loggingTag) {

        var log_data = {};
        log_data.datetime = loggingTag.datetime;
        log_data.value = loggingTag.value;
        log_data.id = loggingTag.id;


        let index = state.logging.findIndex(function( obj ) {
             return obj.tag_id === loggingTag.tag_id;
        });

        if(index !== -1){

            let data_index = state.logging[index].data.findIndex(function( obj ) {
                return obj.id === loggingTag.id;
            });

            // console.log("data index: " + data_index);

            if(data_index !== -1){
                state.logging[index].data.splice(data_index, 1, log_data) ;
            }else{
                state.logging[index].data.push(log_data) ;
            }

           
        }else{
            
            var newTag = {};
            newTag.tag_id = loggingTag.tag_id;
            newTag.data = [];
            newTag.data.push(log_data);

            state.logging.push(newTag) ;
        }   

    },

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}